import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-categorypackagetour-extends',
  templateUrl: './categorypackagetour-extends.component.html',
  styleUrls: ['./categorypackagetour-extends.component.css']
})
export class CategorypackagetourExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  submitted: boolean = false;

  constructor(
    public fb: FormBuilder,
    private packagetourService: PackagetourService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description_category')).focus();
    }, 500);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    this.LoadingModalComponent.show();
    this.packagetourService.saveCategoryPackage(this.item.value).subscribe({
      next: (data: any) => {
        this.alertifyMsg.success('Registro realizado con éxito');
        this.onSubmitEvent.emit(data.data);
        this.LoadingModalComponent.hide();
        (<any>$('#openExtendsCategoryPackagetour')).modal('hide');
        this.resetForm();
      }
    });
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  close() {
    this.item.reset();
  }
}
